export default /* html */ `
<header class="top-bar" *bind:class="[
    navigationState && 'navigation--is-' + navigationState,
    isNavigationOpen && 'navigation--is-open'
  ]">
  <nav
    class="navigation"
    *bind:class="[navigationState && 'navigation--is-' + navigationState]"
    *bind:aria-expanded="isNavigationOpen ? 'true' : 'false'"
    @animationend="handleAnimationEnd"
    >
    <div class="navigation__container" @click="toggleNavigation">
      <ui-button variant="text" to="/">
        <ui-icon slot="icon-start" icon="home_pin"></ui-icon>
        Home
      </ui-button>

      <ui-button variant="text" to="/about-me">
        <ui-icon slot="icon-start" icon="person"></ui-icon>
        About me
      </ui-button>

      <ui-button variant="text" to="/projects">
        <ui-icon slot="icon-start" icon="workspaces"></ui-icon>
        Projects
      </ui-button>

      <!-- <ui-button variant="text" to="/contact">
        <ui-icon slot="icon-start" icon="alternate_email"></ui-icon>
        Contact
      </ui-button> -->
    </div>
  </nav>

  <div class="top-bar__brand-name">
    <span>Digital branch</span>
    <span>Growing the internet</span>
  </div>

  <div class="top-bar__icons-end">
    <!--<ui-icon-button>
      <ui-icon icon="light_mode"></ui-icon>
    </ui-icon-button> -->
    <ui-icon-button @click="toggleNavigation">
      <ui-icon *bind:icon="navigationIcon"></ui-icon>
    </ui-icon-button>
  </div>
</header>

<main>
  <router-view></router-view>
</main>

<footer>
  <span>Powered by <a href="https://scaffoldjs.digitalbranch.nl" target="_blank">ScaffoldJS</a></span>
</footer>

`
